var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"block"},[_c('el-carousel',{staticClass:"wrapper",attrs:{"indicator-position":"none","arrow":"never"}},_vm._l((_vm.banner),function(item,index){return _c('el-carousel-item',{key:index,staticClass:"item"},[_c('img',{attrs:{"src":item.image}})])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }